/**
 * @generated SignedSource<<d4e02d489d993b0f8ae8e4a8e3324d49>>
 * @relayHash cf7a8142cdcbe37d3303e9f1a6d24404
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db18d4aba9bfa7ce2b7393b1ffebf66fee2f7f03be07c4dc73c55dc9b234bbef

import type { ConcreteRequest } from 'relay-runtime';
export type useAgentItemStudioPermissionsQuery$variables = {
  cloudId: string;
};
export type useAgentItemStudioPermissionsQuery$data = {
  readonly atlassianStudio_userSiteContext: {
    readonly userPermissions?: {
      readonly isAbleToCreateAgents: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useAgentItemStudioPermissionsQuery = {
  response: useAgentItemStudioPermissionsQuery$data;
  variables: useAgentItemStudioPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianStudioUserProductPermissions",
      "kind": "LinkedField",
      "name": "userPermissions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAbleToCreateAgents"
        }
      ]
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAgentItemStudioPermissionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAgentItemStudioPermissionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "cf7a8142cdcbe37d3303e9f1a6d24404",
    "id": "db18d4aba9bfa7ce2b7393b1ffebf66fee2f7f03be07c4dc73c55dc9b234bbef",
    "metadata": {},
    "name": "useAgentItemStudioPermissionsQuery",
    "operationKind": "query",
    "text": "query useAgentItemStudioPermissionsQuery($cloudId:ID!){atlassianStudio_userSiteContext(cloudId:$cloudId){__typename,...on AtlassianStudioUserSiteContextOutput{userPermissions{isAbleToCreateAgents}}}}"
  }
};
})();

(node as any).hash = "e36ad0baf31f5ea68cd229d0a5f813d5";

export default node;
